import React from 'react'
import { AboutSectionStyle } from './style'

import aboutFrameImg from "../../images/AboutUS/aboutUsOne.png"
import aboutScreenImg from "../../images/AboutUS/aboutUsTwo.png"



const AboutSection = () => {
  return (
   <AboutSectionStyle>
     {/* About-App-Section-Start */}
     <section className="row_am about_app_section" id='aboutus'>
      {/* container start */}
      <div className="container">
        {/* row start */}
        <div className="row">
          <div className="col-lg-6">
            {/* about images */}
            <div
              className="about_img"
              data-aos="fade-in"
              data-aos-duration={1500}
            >
              <div className="frame_img">
                <img
                  className="moving_position_animatin"
                  src={aboutFrameImg}
                  alt="image"
                />
              </div>
              <div className="screen_img">
                <img
                  className="moving_animation"
                  src={aboutScreenImg}
                  alt="image"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            {/* about text */}
            <div className="about_text">
              <div
                className="section_title"
                data-aos="fade-up"
                data-aos-duration={1500}
                data-aos-delay={100}
              >
                {/* h2 */}
                <h2>
                User <span>Profile</span>
                </h2>
                {/* p */}
                <p>
                Our Riva profile is your personal showcase of athletic achievements and interests. It allows you to highlight your skills. By detailing your preferences and achievements, you make it easier for like-minded athletes to find and connect with you. Your profile serves as a dynamic representation of your athletic journey, helping you engage with others who share similar goals and passions.
                </p>
                {/* UL */}
                <ul className="list">
                  <li data-aos="fade-up" data-aos-duration={1500}>
                    <i className="icofont-verification-check" /> <span className='fw-semibold'>About Me:</span>  Share your sports journey, goals, and passions to provide a personal touch. This helps others understand your motivations and how you contribute to the sports community.
                  </li>
                  <li data-aos="fade-up" data-aos-duration={1500}>
                    <i className="icofont-verification-check tick-icon" /> <span className='fw-semibold'>Social Accounts:</span>  Link your social media profiles to remain connected with fellow athletes and broadcast your achievements. This allows for seamless updates and interactions.
                  </li>
                  <li data-aos="fade-up" data-aos-duration={1500}>
                    <i className="icofont-verification-check" /> <span className='fw-semibold'>Basic Information:</span>Provide essential details like age, gender, and location to give others a snapshot of who you are. This information helps in making relevant connections and understanding your background.
                  </li>
                  <li data-aos="fade-up" data-aos-duration={1500}>
                    <i className="icofont-verification-check" /> <span className='fw-semibold'>Languages:</span>  Indicate the languages you speak to facilitate communication with athletes from diverse regions. This makes networking smoother and more inclusive.
                  </li>
                  <li data-aos="fade-up" data-aos-duration={1500}>
                    <i className="icofont-verification-check" /> <span className='fw-semibold'>Sports Preferences: </span> Showcase your skill levels in various sports, from beginner to expert. This helps others see your areas of expertise and find common ground for collaboration or competition.
                  </li>
                  <li data-aos="fade-up" data-aos-duration={1500}>
                    <i className="icofont-verification-check" /> <span className='fw-semibold'>Achievements:</span> Display your event wins and accomplishments to highlight your dedication and success. This not only inspires others but also adds credibility to your profile.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* row end */}
      </div>
      {/* container end */}
    </section>
    {/* About-App-Section-end */}
   </AboutSectionStyle>
  )
}

export default AboutSection
